import React, { useContext } from 'react';
import styled from 'styled-components';

import Tooltip from 'components/Tooltip';
import NotificationsContext from 'contexts/NotificationsContext';
import NavIconItem from './NavIconItem';
import NotificationsPanel from '../../../../components/NotificationsPanel';
import Icon from '../../../../kingpin/atoms/Icon';

const NewNotificationsDot = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: var(--color-brand-primary);
`;

const Notifications = () => {
  const { openPanel, hasUnSeenNotifications } =
    useContext(NotificationsContext);

  return (
    <>
      <Tooltip content={'Notifications'}>
        <NavIconItem onClick={openPanel}>
          <Icon
            icon="bell"
            color="var(--color-text-secondary)"
            width={19}
            height={19}
          />
          {hasUnSeenNotifications && <NewNotificationsDot />}
        </NavIconItem>
      </Tooltip>
      <NotificationsPanel isCard={false} />
    </>
  );
};

export default Notifications;
